module.exports = __webpack_public_path__ + "assets/cd94a17bdeb4d253a28298aacba1a0a0.svg";